import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import axios from "axios";

// Intercepteur global — ajoute le token Bearer à toutes les requêtes axios
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const API = (process.env.REACT_APP_BACKEND_URL || "https://tangig-production.up.railway.app") + "/api";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const checkingRef = useRef(false);

  const checkAuth = useCallback(async () => {
    if (checkingRef.current) return null;
    checkingRef.current = true;

    const token = localStorage.getItem("token");

    if (!token) {
      setUser(null);
      setLoading(false);
      checkingRef.current = false;
      return null;
    }

    setLoading(true);

    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 5000,
      });

      setUser(response.data);
      return response.data;
    } catch (error) {
      setUser(null);
      localStorage.removeItem("token");
      return null;
    } finally {
      setLoading(false);
      checkingRef.current = false;
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { API };
